import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, SectionTitle } from "@/components/common/Page";
import { severityColor } from "@/pages/legal/legalConfig";
import { Bell, AlertTriangle, CalendarClock } from "lucide-react";

export default function LegalAlerts() {
  const { data } = useQuery({ queryKey: ["legal-alerts"], queryFn: async () => (await api.get("/legal/alerts")).data });
  const reviews = data?.review_alerts || [];
  const renewals = data?.renewal_alerts || [];

  return (
    <div data-testid="legal-alerts-page">
      <PageHeader title="Alerts & Renewals" subtitle="Legal-review reminders and contract renewal / notice deadlines." />

      <SectionTitle className="mb-3"><AlertTriangle className="mr-1 inline h-3.5 w-3.5" /> Legal Review Reminders</SectionTitle>
      <div className="space-y-2" data-testid="review-alerts">
        {reviews.length === 0 && <p className="rounded-lg border border-dashed border-[#2D3F62] px-4 py-8 text-center text-sm text-slate-500">No review reminders.</p>}
        {reviews.map((a, i) => (
          <div key={i} className={`flex items-center gap-2 rounded-lg border px-4 py-2.5 text-sm ${severityColor[a.severity] || severityColor.info}`}>
            <Bell className="h-4 w-4" /> {a.message}
          </div>
        ))}
      </div>

      <SectionTitle className="mb-3 mt-8"><CalendarClock className="mr-1 inline h-3.5 w-3.5" /> Contract Renewals & Notice Deadlines</SectionTitle>
      <div className="space-y-2" data-testid="renewal-alerts">
        {renewals.length === 0 && (
          <p className="rounded-lg border border-dashed border-[#2D3F62] px-4 py-8 text-center text-sm text-slate-500">
            Renewal & non-renewal notice alerts activate once contracts are recorded (Phase C).
          </p>
        )}
        {renewals.map((a, i) => (
          <div key={i} className={`rounded-lg border px-4 py-2.5 text-sm ${severityColor[a.severity] || severityColor.info}`}>{a.message}</div>
        ))}
      </div>
    </div>
  );
}
